define(function () {
    var Binding = function () {
    };
    /**
     * Maps scope params to widget value
     * @param scopeValues
     */
    Binding.prototype.fromScope = function (scopeValues) {
        throw "not implemented";
    };
    /**
     * Maps widget value to scope params
     * @param widgetValue
     */
    Binding.prototype.toScope = function (widgetValue) {
        throw "not implemented";
    };
    /**
     * Checks if scope's parameter affects/is bound to widget's value
     * @param scopeName
     */
    Binding.prototype.isValueAffectedBy = function (scopeName) {
        throw "not implemented";
    };
    return Binding;
});


//////////////////
// WEBPACK FOOTER
// ./~/fcse-binding/binding.js
// module id = 59
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23